const initialState = {
  identInformation: {
    // nationality: {
    //  iso2: 'DE',
    //  iso3: 'DEU',
    //  name: 'Deutschland',
    //  passports: []
    // },
    nationality: '',
    identCard: '',
    identType: ''
  }
}

const ActivationIdentModule = {
  namespaced: true,
  state: initialState,
  getters: {
    identificationFull: state => {
      return state.identInformation
    },
    identificationCore: state => {
      return {
        identMethod: state.identInformation.identType,
        nationality: state.identInformation.nationality.iso3,
        medium: state.identInformation.identCard.key
      }
    },
    getNationality: state => {
      if (state.identInformation.nationality?.name) {
        return state.identInformation.nationality.name
      } else return ''
    },
    getIdentCard: state => {
      return state.identInformation.identCard
    },
    getIdentType: state => {
      return state.identInformation.identType
    }
  },
  mutations: {
    storeIdent (state, { nationality, identCard, identType }) {
      state.identInformation = {
        identCard: identCard,
        nationality: nationality,
        identType: identType
      }
    },
    resetIdentType (state) {
      state.identInformation.identType = ''
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  }
}

export default ActivationIdentModule
